import React from 'react';
import { useTalkFlowRecordingDuration } from '@/hooks/apiHooks';
import { Container, Divider, Time } from './styles';
import { Body2 } from '@/components/@IntranetLibrary/Typography';
import DocumentAgentIcon from '@/components/Document/DocumentAgentIcon';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ICON_WIDTH = 20;

const RecordingDuration = () => {
  const { data } = useTalkFlowRecordingDuration();
  const { t } = useTranslation();

  if (!data?.duration) {
    return null;
  }

  const totalSeconds = data.duration;
  const days = Math.floor(totalSeconds / (60 * 60 * 24));
  const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));

  return (
    <Container>
      <Box
        sx={{
          borderRadius: '100%',
          overflow: 'hidden',
          width: `${ICON_WIDTH}px`,
          height: `${ICON_WIDTH}px`,
        }}
      >
        <DocumentAgentIcon width={ICON_WIDTH} height={ICON_WIDTH} />
      </Box>
      <Body2>{t('Document.AI 회의록으로 절약된 시간 (최근 30일 기준)')}</Body2>
      <Divider />
      {days > 0 && <Time>{days.toLocaleString()}</Time>}
      <Body2>{t('Document.일')}</Body2>
      <Time>{hours}</Time>
      <Body2>{t('Document.시간')}</Body2>
    </Container>
  );
};

export default RecordingDuration;
